import useOnValueChange from "../../../hooks/useOnValueChange";
import { InputProps } from "../Calculator";
import NumberInput from "../../BuildingBlocks/NumberInput/NumberInput";

const TITLE = "תשואה שנתית ממוצעת";
const SUBTITLE = "מה תהיה התשואה הצפויה בכל שנה בממוצע";
const NAME = "yearly-intrest-rate";

const AnnualIntrestRate = ({ contextKey }: InputProps) => {
  const onValueChange = useOnValueChange(contextKey);

  return (
    <NumberInput
      title={TITLE}
      placeholder={SUBTITLE}
      name={NAME}
      onlyPositive
      isRate
      onChange={(value: number) => onValueChange(value)}
    />
  );
};

export default AnnualIntrestRate;
